import React, { Component } from 'react';

import Crime from './Crime';
import Dtp from './Dtp';
import DtpMap from './DtpMap';

import { CaseMainTitle } from '../../components/newDesign/CaseMainTitle';
import { MainWrapper } from '../../components/newDesign/MainWrapper/MainWrapper';
import { RadioGroup } from '../../components/newDesign/RadioGroup';
import { logCaseVisit } from '../../services/api';

const NAME_COMP = {
  'Криминогенная обстановка': <Crime />,
  ДТП: <Dtp />,
  'Карта опасных участков': <DtpMap />,
};

// соответствие подписей в радиокнопках кейсам бэка
const CASE_NAME_BY_SUBTAB = {
  'Криминогенная обстановка': 'CRIME',
  ДТП: 'RTA',
  'Карта опасных участков': 'RTA',
};

class Safety extends Component {
  constructor(props) {
    super(props);
    this.state = {
      radio: Object.keys(NAME_COMP)[0],
    };
    // чтобы не дублировать запросы при одинаковом кейсе
    this.lastLoggedCaseName = null;
  }

  componentDidMount() {
    this.logCaseVisitForCurrentRadio();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.radio !== this.state.radio || prevProps.subtabs !== this.props.subtabs) {
      this.logCaseVisitForCurrentRadio();
    }
  }

  logCaseVisitForCurrentRadio = () => {
    const { subtabs } = this.props;
    const { radio } = this.state;

    const currentSubtab = Array.isArray(subtabs)
      ? subtabs.find((subtab) => subtab.name === radio)
      : null;

    // если бэк начнёт отдавать subtab.caseName — используем его
    const fromBackend = currentSubtab && currentSubtab.caseName;
    const fromLocalMap = CASE_NAME_BY_SUBTAB[radio];

    const caseName = fromBackend || fromLocalMap;

    if (caseName && caseName !== this.lastLoggedCaseName) {
      this.lastLoggedCaseName = caseName;
      logCaseVisit(caseName).catch(() => {});
    }
  };

  radioChange = (value) => {
    this.setState({
      radio: value.target.value,
    });
  };

  render() {
    const { subtabs } = this.props;
    return (
      <MainWrapper>
        <CaseMainTitle>Общественная безопасность</CaseMainTitle>
        <RadioGroup
          onChange={this.radioChange}
          value={this.state.radio}
          list={subtabs.map((i) => ({
            key: i.name,
            value: i.name,
          }))}
        />
        {Object.keys(NAME_COMP).map((nav) => {
          if (nav === this.state.radio) return NAME_COMP[nav];
          else return null;
        })}
      </MainWrapper>
    );
  }
}

export default Safety;
